import React from 'react';
import { styled } from '@this/constants/themes';

import { reportError } from '@this/lib/bugsnag';
import type Flight from '@this/domain/flight/flight2';

import Text from '../../../shared/text/text';

type Props = {
  flight: Flight | null | undefined;
};

const ReserveConfirmFlightTr: React.FC<Props> = ({ flight }) => {
  try {
    return flight ? (
      <>
        <Text text={flight.description} />
        {flight.priceDetailArray.map((d, i) => (
          <PriceDetail key={i}>
            <p>{d.title}</p>
            <p>{d.price}</p>
          </PriceDetail>
        ))}
      </>
    ) : (
      <span>-</span>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

const PriceDetail = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 100px;
`;

export default ReserveConfirmFlightTr;
